import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

import { DarkSplash, GRID_BREAKPOINT_S, Link, MAX_CONTENT_WIDTH } from 'modules/UI';

export const Container = styled(DarkSplash)`
  margin-bottom: ${tokens.space.loosest};
`;

export const CallOut = styled.div`
  width: 100%;
  max-width: ${MAX_CONTENT_WIDTH};
`;

export const CallOutContent = styled.div`
  margin-top: 100px;
  max-width: 444px;
  margin-left: 96px;

  @media screen and (max-width: ${GRID_BREAKPOINT_S}) {
    margin-left: 0;
    margin-top: 46px;
  }
`;

export const Title = styled.h1`
  font-weight: normal;
  font-size: 50px;
  max-width: 694px;
  font-family: ${tokens.fonts.primary};
  line-height: 55px;
  color: ${tokens.colors.white};
  text-shadow: 0px 1px 13px rgba(0, 0, 0, 0.4);
  margin: 0;

  @media screen and (max-width: ${GRID_BREAKPOINT_S}) {
    font-size: 36px;
    line-height: 42px;
  }
`;

export const Description = styled.p`
  font-size: ${tokens.fontSizes.m};
  line-height: ${tokens.lineHeights.m};
  max-width: 490px;
  font-family: ${tokens.fonts.primary};
  font-weight: 500;
  color: ${tokens.colors.white};
  margin-top: 20px;
  margin-bottom: ${tokens.space.large};

  @media screen and (max-width: ${GRID_BREAKPOINT_S}) {
    font-size: ${tokens.fontSizes.l};
    line-height: ${tokens.lineHeights.l};
    font-weight: 300;
    margin-top: ${tokens.space.small};
    margin-bottom: ${tokens.space.larger};
  }
`;

export const Actions = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: ${tokens.space.regular};
  margin-bottom: 90px;
  justify-content: flex-start;
  width: max-content;

  @media screen and (max-width: ${GRID_BREAKPOINT_S}) {
    margin-bottom: 0;
    justify-content: center;
  }
`;

type ActionProps = {
  isMobileHidden?: boolean;
};

export const Action = styled(Link)<ActionProps>`
  box-sizing: border-box;

  @media screen and (max-width: ${GRID_BREAKPOINT_S}) {
    height: 48px;
    width: 100%;
    font-size: ${tokens.fontSizes.m};
    display: ${({ isMobileHidden = false }): string | false => isMobileHidden && 'display: none'};
  }
`;

export const ScrollDown = styled.div`
  display: none;

  @media screen and (max-width: ${GRID_BREAKPOINT_S}) {
    display: block;
  }
`;

export const ScrollDownIcon = styled.img`
  margin: 43px auto 10px;
  display: block;
`;
